import { render, staticRenderFns } from "./Roulette.vue?vue&type=template&id=7f19bb8c&scoped=true"
var script = {}
import style0 from "./Roulette.vue?vue&type=style&index=0&id=7f19bb8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f19bb8c",
  null
  
)

export default component.exports